import React from 'react';
import styled from 'styled-components';
import { Main } from 'styles/themeColors';
import { BorderRadius } from 'styles/themeBorderRadius';
import { FontSize, FontWeight } from 'lib/styles';

const Pill = styled.span<{ $bgColor: string }>`
    display: inline-block;
    padding: 6px 14px;
    border-radius: ${BorderRadius.s};
    font-size: ${FontSize.small};
    background-color: ${({ $bgColor}) => $bgColor};
    color: ${Main.white};
    font-weight: ${FontWeight.bold};
    line-height: 16px;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    white-space: nowrap;
`;

interface Props {
    name: string;
    colorHash: string;
    isActive?: boolean;
}

const BadgePill = ({ name, colorHash, isActive = true }: Props) => {
    if (!name || !colorHash) return null;

    return (
        <Pill $bgColor={colorHash}>
            {name}
        </Pill>
    );
};

export default BadgePill;
